import type { ReactNode } from 'react';

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={[
      'rounded border bg-neutral-0 border-neutral-200 dark:bg-neutral-800 dark:border-neutral-700',
      className,
    ].join(' ')}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action }: { title: ReactNode; subtitle?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-4 border-b border-neutral-200 px-4 py-3 dark:border-neutral-700">
      <div className="min-w-0">
        <h3 className="truncate text-md font-semibold text-neutral-800 dark:text-neutral-100">{title}</h3>
        {subtitle ? <p className="truncate text-xs text-neutral-500">{subtitle}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}

export function CardBody({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}
